import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { weakR230522NormalSubSocketBunja } from '.';
import { TablesJsonValue } from '../../model/prex.v2.r230522.messages.subscription.server';

type ExtractSnapshot<T> = T extends { s?: infer S } ? S : never;
type R230522NormalSubTableTopic = keyof TablesJsonValue;
type AccumulatedTable<K extends R230522NormalSubTableTopic> = ExtractSnapshot<TablesJsonValue[K]>;
export type AccumulatedTables = { [K in R230522NormalSubTableTopic]: AccumulatedTable<K> };

interface TableUpdatesJsonValue {
  s?: Record<string, object>; // snapshot
  i?: Record<string, object>; // insert
  u?: Record<string, object>; // update
  d?: Record<string, void>; // delete
}

// 각 테이블 토픽별 누적된 데이터를 관리함
export const weakR230522NormalSubTablesBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { r230522NormalSubSocket } = bunja.use(weakR230522NormalSubSocketBunja);
  const tablesAtom = atom<AccumulatedTables>({} as AccumulatedTables);

  bunja.effect(() =>
    r230522NormalSubSocket.on('r230522table', (tablesUpdate) => {
      const tables = { ...store.get(tablesAtom) };
      for (const [tableTopic, update] of Object.entries(tablesUpdate)) {
        const { s, i, u, d } = update as TableUpdatesJsonValue;
        const table = s ? { ...s, ...i } : { ...tables[tableTopic as R230522NormalSubTableTopic], ...i };
        if (u) {
          for (const [key, value] of Object.entries(u)) {
            if (key in table) table[key] = { ...table[key], ...value };
          }
        }
        if (d) for (const key of Object.keys(d)) delete table[key];
        (tables[tableTopic as R230522NormalSubTableTopic] as unknown) = table;
      }
      store.set(tablesAtom, tables);
    }),
  );

  return { tablesAtom };
});
weakR230522NormalSubTablesBunja.debugLabel = 'weakR230522NormalSubTablesBunja';
